import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export function Modal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    children = _ref.children;
  return /*#__PURE__*/_jsx(ModalWindow, {
    open: open,
    onClose: onClose,
    width: 610,
    children: children
  });
}